import React, { useState, useEffect } from 'react';
import './MobileAppSection.scss';

const CAROUSEL_DATA = [
  {
    id: 1,
    title: "Multi-Broker Integration",
    badge: "Unified",
    icon: "🔗",
    description: "Seamlessly connect all your brokerage accounts and manage them from one unified dashboard."
  },
  {
    id: 2,
    title: "Family Account Consolidation",
    badge: "Multi-Portfolio",
    icon: "👨‍👩‍👧",
    description: "Manage multiple portfolios across family members or clients with complete visibility and control."
  },
  {
    id: 3,
    title: "Bulk Trade Execution",
    badge: "Precision",
    icon: "⚡",
    description: "Execute large-scale trades across multiple stocks instantly with precision and zero manual errors."
  },
  {
    id: 4,
    title: "Custom Trading Strategies",
    badge: "Personalized",
    icon: "🎯",
    description: "Design, backtest, and deploy personalized strategies aligned with your financial goals and risk appetite."
  },
  {
    id: 5,
    title: "Portfolio AI Agent",
    badge: "AI-Powered",
    icon: "🤖",
    description: "Interact with your portfolio using natural language — analyze performance, execute trades, and get recommendations instantly."
  }
];

const AUTOPLAY_INTERVAL = 5000;

const MobileAppSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % CAROUSEL_DATA.length);
    }, AUTOPLAY_INTERVAL);
    return () => clearInterval(timer);
  }, [currentIndex]);

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? CAROUSEL_DATA.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % CAROUSEL_DATA.length);
  };

  const currentCard = CAROUSEL_DATA[currentIndex];

  return (
    <div className="mobile-app-section container-fluid">
      <div className="mobile-app-content">
        <div className="mobile-app-left">
          {/* <div className="pill-badge">
            <span className="icon">📱</span> MOBILE APP
          </div> */}
          <h2 className="title">Markets in Your Pocket</h2>
          <p className="subtitle">
            Take the full power of AlgoFabric wherever you go. From analysis to one-click execution. From insights to execution — AlgoFabric brings the entire investment lifecycle into one seamless platform.
          </p>

          <div className="feature-carousel-card">
            <div className="card-top-row">
              <div className="card-number">{String(currentIndex + 1).padStart(2, '0')}</div>
            </div>
            <h5 className="card-title">{currentCard.title}</h5>
            <div className="card-subtitle">{currentCard.description}</div>
            <div className="progress-bar">
              <div key={currentIndex} className="progress-fill"></div>
            </div>
          </div>

          <div className="carousel-controls">
            <div className="dots">
              {CAROUSEL_DATA.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
            <div className="arrows">
              <button className="arrow-btn left-arrow" onClick={handlePrev}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button className="arrow-btn right-arrow" onClick={handleNext}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Download badges intentionally removed (per design request). */}
        </div>

        <div className="mobile-app-right">
          {/* Background circle lines graphic placeholder */}
          <div className="bg-circles">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
          </div>



          {/* Phones Mockup Placeholder */}
          <div className="phones-container">
            <img 
              src="/assets/images/landingv2/Group 1.png" 
              alt="Phone Mockup Group" 
              className="phone-mockup-group" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppSection;
